import {createSelector} from "reselect";

const ModalStateSelector = (state) => state.modals;

export const modalsSelector = createSelector(
  [ModalStateSelector],
  (modals) => modals.items
);
